import React from 'react';
import { appLinks } from './constants';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  isLoggedIn: boolean;
  children: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isLoggedIn,
  children,
}) => {
  if (!isLoggedIn) {
    return <Navigate to={appLinks.LOGIN} replace />;
  }
  return children;
};

export default ProtectedRoute;
